
















































































import { getIndexFromList, isNullOrEmpty, maxLengthArrayFields, placeHolderArrayFields, splitStringByCharacter } from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { Combobox } from '../../core/components';
import Input from '../../core/components/Input.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Loading from 'vue-loading-overlay';

@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        Input
    }
})
export default class DynamicForm extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() fields: any;
    valid: boolean = false;
    maxLengthArrayField: number = maxLengthArrayFields;

    //methods
    mounted() {
       
    }

    updateFormModel(value, index){
        this.fields[index]['model'] = value
    }
    

    get validateForm(): Vue & { validate: () => boolean } {
        return this.$refs.dynamicFormFrame as Vue & { validate: () => boolean };
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    updateFormStatus(value: boolean){
        this.$emit('dynamic-fields-validation', value);
    }

    firstCharacterHasKey(inputValue){
        if(inputValue && inputValue.charAt(0) === '{'){
            return true
        }else{
            this.updateFormStatus(false)
            return 'El formato es' + placeHolderArrayFields
        }
    }
    lastCharacterHasKey(inputValue){
        if(inputValue && inputValue.charAt(inputValue.length - 1) === '}'){
            return true
        }else{
            this.updateFormStatus(false)
            return 'El formato es' + placeHolderArrayFields
        }
    }

    compareWithSecondValue(currentInputValue, valueToCompare, maxNum, compareLabel){
        let firstValue = splitStringByCharacter(currentInputValue, ',');
        let secondValue = splitStringByCharacter(valueToCompare, ',');
        let currentValueLength = firstValue.length;
        let secondValueLength = secondValue.length;
       
        if (currentValueLength > maxNum || secondValueLength > maxNum) {
            this.updateFormStatus(false)
            return 'Máximo ' + maxNum + ' caracteres';
        }

        if (currentValueLength !== secondValueLength) {
            this.updateFormStatus(false)
            return 'Debe tener la misma longitud que ' + compareLabel;
        } else {
            this.updateFormStatus(true)
            return true;
        }
    }

    compareValues( currentInputValue, key_to_compare) {
        //esta funcion compara los campos RxFilterData y RxFilterMask
        let max_num = this.maxLengthArrayField;
        let self = this;

        let indexToCompare = getIndexFromList(this.fields, 'key', key_to_compare);
        if (indexToCompare !== -1) {
            let value_to_compare = this.fields[indexToCompare]['model'];
            let compareLabel = this.fields[indexToCompare]['label'];

            let field = {
                isEmpty: isNullOrEmpty(currentInputValue),
                currentValueIsValid: self.lastCharacterHasKey(currentInputValue) && self.firstCharacterHasKey(currentInputValue),
                checkBoth: self.compareWithSecondValue(currentInputValue,value_to_compare, max_num, compareLabel),
                isValid() {
                    if(field.isEmpty && isNullOrEmpty(value_to_compare)){
                        return true
                    }else{
                        //ambos campos tienen que tener la misma longitud
                       if(typeof(field.currentValueIsValid) === 'string'){
                        return field.currentValueIsValid
                       }else if(typeof(field.checkBoth) === 'string'){
                        return field.checkBoth
                       }
                       return true                    
                    }
                    
                }
            }

            return field.isValid();
        }
    }
}
